export const CheckedIcon = ({
  width = 13,
  height = 16,
  color = "currentColor"
}: {
  width?: number;
  height?: number;
  color?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 13 16"
    fill="none"
  >
    <g clipPath="url(#clip0_1981_7682)">
      <path
        d="M12.7272 3.62995C13.0899 3.99268 13.0899 4.58174 12.7272 4.94446L5.29864 12.373C4.93592 12.7358 4.34685 12.7358 3.98413 12.373L0.269845 8.65875C-0.0928781 8.29602 -0.0928781 7.70696 0.269845 7.34424C0.632568 6.98151 1.22163 6.98151 1.58435 7.34424L4.64284 10.3998L11.4156 3.62995C11.7783 3.26723 12.3674 3.26723 12.7301 3.62995H12.7272Z"
       fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1981_7682">
        <rect
          width="13"
          height="14.8571"
          fill="white"
          transform="translate(0 0.571411)"
        />
      </clipPath>
    </defs>
  </svg>
);
